import React, { useEffect, useRef, useState } from 'react'
import { LocaleCodes } from '../../../constants/localization.constants'
import ImgUtil from '../../../utils/img.utils'
import Button from '../button'
import Typography from '../typography'
import WrapperImage from '../wrapperImage'
import { BannerForward, IconLinksSection, Navbar, NavbarContainer } from './style'
import { NavLinks } from './subcomponents/navLinks'
import { NavButton, NavHamburgerIcon, NavLogo, TopHatLinks } from './subcomponents/navParts'
import { SearchIcon } from './subcomponents/searchIcon'
const FullHeader = ({ headerData, uiPathSrc }: any) => {
  if (!headerData) return null
  const [openMenu, setOpenMenu] = useState<boolean>(false)
  const navbarRef = useRef<any>(null)

  const { externalUrl, text, internalLink } = headerData.primaryCta
  const internalLinkSlug = internalLink?.slug && uiPathSrc + internalLink?.slug
  const btnURL = externalUrl || internalLinkSlug || '#'
  const langCode = headerData?.node_locale
  const handleResize = () => {
    if (window.innerWidth > 768) {
      setOpenMenu(false)
      document.body.style.overflow = 'auto'
    }
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <>
      <Navbar data-cy="fullHeader" ref={navbarRef} openMenu={openMenu}>
        <NavbarContainer openMenu={openMenu}>
          <div className="Navbar__Mobile_Top">
            {<NavLogo uiPathSrc={uiPathSrc} />}
            {<NavHamburgerIcon openMenu={openMenu} setOpenMenu={setOpenMenu} />}
          </div>

          <NavLinks navLinks={headerData.menuGroups} openMenu={openMenu} uiPathSrc={uiPathSrc} />

          <IconLinksSection openMenu={openMenu}>
            <SearchIcon />
            {headerData.topHatLinks && <TopHatLinks headerData={headerData} />}
          </IconLinksSection>

          {<NavButton url={btnURL} text={text} />}
        </NavbarContainer>
      </Navbar>

      {langCode === LocaleCodes.ENGLISH.code && (
        <BannerForward>
          <div
            className="Banner__forward--conainer"
            onClick={event => (window.location.href = '/events/forward')}>
            <WrapperImage
              src={ImgUtil.getResizedImageUrl(
                'https://images.ctfassets.net/5965pury2lcm/7BCcmLZU3OeCG6FzjPjMoS/ef988802ba83a18e4fe8284518b2531a/Forward6-banner-logo.svg',
                ''
              )}
              alt="Forward 6"
            />

            <Typography type="header5">
              See AI at work at the world's premier automation event.
            </Typography>

            <Button
              text="Register now"
              icon={true}
              type="primary"
              theme="light"
              className="Register--Link"
            />
          </div>
        </BannerForward>
      )}
    </>
  )
}

export default FullHeader
